import {Perfil} from "./perfil"

export class GrupoUsuario {
  id: string;
  gusNome: string;
  perfis:Array<Perfil>;
}
